import React from 'react';
import type { AutocompleteRenderOptionState } from '@mui/material/Autocomplete';

import Typography from '../../Typography';
import { TypographyVariants } from '../../Typography/types';
import { SelectSize } from '../types';

const VARIANT_CONFIG: { [key in SelectSize]: TypographyVariants } = {
  large: 'body-short-01',
  medium: 'body-short-02',
};

export const defaultOptionLabelRenderer = (
  label: string,
  state: AutocompleteRenderOptionState,
  size: SelectSize,
) => {
  const variant = VARIANT_CONFIG[size];

  return (
    <Typography
      className="truncate"
      color={state.selected ? 'text-text-primary' : 'text-text-secondary'}
      variant={variant}>
      {label}
    </Typography>
  );
};

export const defaultTagLabelRenderer = (label: string, size: SelectSize) => {
  const variant = VARIANT_CONFIG[size];

  return (
    <Typography className="truncate" color="text-text-primary" variant={variant}>
      {label}
    </Typography>
  );
};
